

export const leadersData = [
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/sanjeev_kothari.jpg",
    name: "Mr. Sanjeev Kothari",
    title: "Co-founder & Director",
    text: "Industry veteran with 19+ years experience, Sanjeev co-founded Orion to provide meaningful employment to India’s youth. He has been instrumental in creating staffing, technology and content verticals at Orion.",
  },
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/manish_agarwal.jpg",
    name: "Mr. Manish Agarwal",
    title: "Co-founder & Director",
    text: "Manish co-founded Orion with a vision to bridge demand-supply gap in India’s skilled workforce. With over 19 years of deep expertise, he set up & directs processes, governance, finance as well as CSR at Orion. ",
  },
];

export const teamData = [
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/somnath_banerjee.jpg",
    name: "Mr. Somnath Banerjee",
    title: "CEO, Co-founder (Orion Corporate Alliance)",
    
  },
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/nitin_agarwal.jpg",
    name: "Mr. Nitin Agarwal",
    title: "Director (Operations)",
  },

  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/deepraj_paul.png",
    name: "Mr. Deepraj Paul",
    title: "Director (Operations & Contentgrill)",
  },
/*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/niladri_banerjee.jpg",
    name: "Mr. Niladri Banerjee",
    title: "Associate Director (CSR Implementation)",
  },
*/
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1640877803/orion-new-website/about_us_new_images/staffs/4_Pran_Krishna_Das_xgqirc.jpg",
    name: "Pran Krishna Das",
    title: "Director (Govt. Business)",
  },
  */
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1641189485/orion-new-website/about_us_new_images/staffs/9_Niladri_ggm4g4.jpg",
    name: "Niladri Banerjee",
    title: "Associate Director (Operations - CSR, School Projects)",
  },
  */
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1641189485/orion-new-website/about_us_new_images/staffs/5_Priyadeep_Sinha_v1g4h5.jpg",
    name: "Priyadeep Sinha",
    title: "Chief Product Officer",
  },
*/

  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/rakesh_kumar_jha.jpg",
    name: "Mr. Rakesh Kumar Jha",
    title: "Chief Financial Officer (Finance & HR)",
  },
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1640878179/orion-new-website/about_us_new_images/staffs/10_Siddhartha_Dey_vlgexv.jpg",
    name: "Siddhartha Dey",
    title: "Vice President (Operations)",
  },
  */
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/semal_kumar_yadav.jpg",
    name: "Mr. Semal Kumar Yadav",
    title: "Vice President (Finance)",
  },
  /*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/santu_kumar_ghosh.jpg",
    name: "Mr. Santu Kumar Ghosh",
    title: "Vice President (Projects)",
  },
  */

  /*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/soumya_brata_dhar.jpg",
    name: "Mr. Soumya Brata Dhar",
    title: "Vice President (Placements)",
  },
  */

  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/nilayan_chakraborty.png",
    name: "Mr. Nilayan Chakraborty",
    title: "Vice President",
  },
  {
    image:
      "/images/pritam_mukherjee.png",
    name: "Mr. Pritam Mukherjee",
    title: "Vice President (Partnership & Alliances)",
  },
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1640878493/orion-new-website/about_us_new_images/staffs/15_Somnath_frm6ge.jpg",
    name: "Mr. Somnath Acharya",
    title: "Vice President (Operations)",
  },
  */
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/debprasad_saha.jpg",
    name: "Mr. Debprasad Saha",
    title: "Vice President (Government Projects)",
  },
  
  /*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/rajib_kumar_singha.jpg",
    name: "Mr. Rajib Kumar Singha",
    title: "Vice President (CSR Implementation)",
  },
  */

  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/manjari_singh.jpg",
    name: "Ms. Manjari Singh",
    title: "Vice President (Study Abroad)",
  },
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/debtirtha_chakraborty.jpg",
    name: "Mr. Debtirtha Chakraborty",
    title: "Vice President (Corporate Alliance)",
  },
  
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1641560067/orion-new-website/about_us_images/WhatsApp_Image_2022-01-07_at_4.38.34_PM_gb8tbc.jpg",
    name: "Mr. Rohit Venaik",
    title: "Assistant Vice President (Business Dev)",
  },
  */
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/ruptan_ghosh.png",
    name: "Mr. Ruptan Ghosh",
    title: "Assistant Vice President",
  },
  /*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/sarbajit_kundu.jpg",
    name: "Mr. Sarbajit Kundu",
    title: "Assistant Vice President (Operations)",
  },
  */
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/arijit_majumder.jpg",
    name: "Mr. Arijit Majumder",
    title: "Assistant Vice President (Human Resources)",
  },
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1641189485/orion-new-website/about_us_new_images/staffs/18_Mehak_grkf8a.jpg",
    name: "Mehak Sarraf",
    title: "General Manager (Orion Infinity HR Solutions)",
  },
  */
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/supriyo_dutta.png",
    name: "Mr. Supriyo Dutta",
    title: "General Manager",
  },
  /*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/abhijit_kundu.png",
    name: "Mr. Abhijit Kundu",
    title: "General Manager",
  },
  */
  {
    image:
      "/images/dhritiman_bhattacharya.jpg",
    name: "Mr. Dhritiman Bhattacharya",
    title: "General Manager (Placements)",
  },
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/nabanita_banerjee.jpg",
    name: "Ms. Nabanita Banerjee",
    title: "General Manager",
  },
  
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/dipambita_sarkar.jpg",
    name: "Ms. Dipambita  Sarkar",
    title: "General Manager (Orion Corporate Alliance)",
  },
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/sunil_todowal.jpg",
    name: "Mr. Sunil Todowal",
    title: "General Manager",
  },
  /*
  {
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/about_us/surajit_marik.jpg",
    name: "Mr. Surajit Marik",
    title: "General Manager",
  },
  */
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1640878803/orion-new-website/about_us_new_images/staffs/19_Prema_wusf0z.jpg",
    name: "Prerna Joshi",
    title: "General Manager (TITP - Japan)",
  },
  */
  
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1641560068/orion-new-website/about_us_images/WhatsApp_Image_2022-01-07_at_4.35.26_PM_jwcg6w.jpg",
    name: "Raj Kothari",
    title: "Vice President (Business Dev)",
  },
  */
  // {
  //   image:
  //     "https://res.cloudinary.com/learnhat/image/upload/v1640878365/orion-new-website/about_us_new_images/staffs/13_Sarbajit_h38qvb.jpg",
  //   name: "Sarbajit Kundu",
  //   title: "Vice President (Operations)",
  // },

  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1640878433/orion-new-website/about_us_new_images/staffs/14_Koushik_ztsqys.jpg",
    name: "Koushik Bhattacharyya",
    title: "Asst Vice President (Corporate Alliance)",
  },
  */
  
  /*
  {
    image:
      "https://res.cloudinary.com/learnhat/image/upload/v1640879036/orion-new-website/about_us_new_images/staffs/23_Rajib_k53fgm.jpg",
    name: "Rajib Singha",
    title: "Asst. Vice President (CSR - Operations)",
  },
  */
];



export const dataAwardsNew = [
  {
    id: "1",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/1_4_qn4yzt.jpg",
    text:
      "National Entrepreneurship Award 2017 awarded to Orion Edutech in recognition of our initiative in Skill Development by (late) Shri Arun Jaitley (then Finance Minister of India) and Shri Dharmendra Pradhan (Minister of Skill Development & Entrepreneurship, Govt. of India)",
  },

  {
    id: "2",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/2_4_xst3gp.jpg",
    text:
      "Best Vocational Training Company Award 2017 received from hon'ble MP Dr. Udit Raj & Shri S C Agarwal (Member of Managing Committee) by ASSOCHAM",
  },

  {
    id: "3",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/3_5_gyuk67.jpg",
    text:
      "Best Vocational Training Institute Award 2017 received from Shri Rajiv Pratap Rudy (then Minister of Skill Development & Entrepreneurship, Govt. of India) by ASSOCHAM",
  },

  {
    id: "4",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/4_4_e40ymb.jpg",
    text:
      "Ministry of Rural Development (MoRD) certified Orion Edutech as Champion Employer for 2017",
  },

  {
    id: "5",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/5_1_gnr70w.jpg",
    text:
      "Best Skill Development Training Provider Award received at the Indo-Global Education Summit & Expo (2017)",
  },

  {
    id: "6",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/6_2_gn9wdc.jpg",
    text:
      "Best Institute - Innovation Award received at Indo-Global Education Summit & Expo (2017)",
  },

  {
    id: "7",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/7_1_pzefc6.jpg",
    text:
      "Orion Edutech awarded as the Best Skill Development Training Company by Econs (2017)",
  },

  // {
  //   id: "8",
  //   image:
  //     "https://res.cloudinary.com/learnhat/image/upload/v1641194446/orion-new-website/awards_and_recognition/8_2_j8jju7.jpg",
  //   text:
  //     "‘CRISIL MSE * 2’ performance and credit rating by NSIC-CRISIL indicating high credit worthiness received by Orion Edutech",
  // },

  {
    id: "9",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/9_2_krehh2.jpg",
    text:
      "MSME Excellence Award for Best Practices in Service Sector received from BCC&I (2016)",
  },

  {
    id: "10",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/10_2_pmlhw1.jpg",
    text:
      "Silver Trophy awarded from Mr. Bandaru Dattatreya (then Minister of State for Labour And Employment, Govt. of India) by ASSOCHAM",
  },

  {
    id: "11",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/11_2_bourt8.jpg",
    text:
      "Skill Champion of India Award received from Mr. Pallam Raju (then HRD Minister, Govt. of India) by FICCI (2013)",
  },

  {
  
    id: "12",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/12_oggq41.jpg",
    text:
      "Best Vocational Training Institute Award received from Indian Education Congress in 2011",
  },

  {
    id: "13",
    image:
      "https://orionfiles.s3.ap-south-1.amazonaws.com/orionedutech_website/awards_recognition/13_1_kjsaf9.jpg",
    text:
      "Franchisor of the Year Award received from Shri Pradeep Jain (then Minister of State for Rural Development, Govt. of India) by Franchise Plus",
  },
];
